export class SearchCondition {
  class_code: string = null
  name: string = ""
  page: number = 1
  row_count: number =  100
}

export class Classification {
  id: number
  class_code: number
  name: string
  full_count: number
  is_checked: boolean = false

  constructor(x: any){
    this.id = x.id;
    this.class_code = x.class_code;
    this.name = x.name;
    this.full_count = x.full_count;
  }
}